import { registerComponent } from "lib/components";
import { BigqueryTableViewerApp } from "./main";

registerComponent({ BigqueryTableViewerApp });
